<template>
  <div>
    <h1>Staff Credit Tracking</h1>

    <!-- bof request list -->
    <staff-project-list-table
      :editable="editable"
      :staff-id="staffId"
      :is-admin="isAdmin"
    />
    <!-- eof request list -->

    <!-- bof child staff request list -->
    <div class="card my-2">
      <div class="card-body">
        <div class="card-title">
          <h3>Staff Requests</h3>
        </div>
        <staff-credit-filter-and-table :staff-id="staffId" />
      </div>
    </div>
    <!-- eof child staff request list -->

    <!-- bof other staff request list -->
    <div
      v-if="!isAdmin"
      class="card my-2"
    >
      <div class="card-body">
        <div class="card-title">
          <h3>Other Staff</h3>
        </div>
        <other-staff-credit-table :staff-id="staffId" />
      </div>
    </div>
    <!-- eof other staff request list -->
  </div>
</template>

<script>
export default {
  name: "StaffCreditTrackingTable",
  props: {
    staffId: {
      type: Number,
      default: 0,
    },
    requestList: {
      type: Array,
      default: () => [],
    },
    editable: {
      type: Boolean,
      default: false,
    },
    isAdmin: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped></style>
